import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=6486d56d"
import script from "../js/components/Team.js?vue&type=script&lang=js&external"
export * from "../js/components/Team.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports